export default __webpack_public_path__ + "891d34e83d31080850df3ac0eaeb0db9.png";